import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { onDemandExtraction } from "./api";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import useAppStore from "../../store/global";
import { useFetchReportNamesForPoS } from "./api";
import { formatInTimeZone, toZonedTime } from "date-fns-tz";

export default function OnDemandModal({ show, onHide, id, posForOnDemand }) {
  const navigate = useNavigate();
  const [dateForOnDemand, setDateForOnDemand] = useState(null);
  const [selectedPos, setSelectedPos] = useState(null);
  const [selectedPosId, setSelectedPosId] = useState(null);
  const [loading, setLoading] = useState(false);
  const { dateRange, setDateRange, jobDateRange, setJobDateRange } =
    useAppStore();
  const [reportType, setReportType] = useState("all");
  const [extractionType, setExtractionType] = useState("");
  const [jobFrequency, setJobFrequency] = useState("one time");
  const [time, setTime] = useState("");

  const { data, isLoading, isError } = useFetchReportNamesForPoS(selectedPosId);

  const handleDateChange = (e) => {
    setDateForOnDemand(e.target.value);
  };

  const handlePosChange = (e) => {
    const value = JSON.parse(e.target.value);
    console.log("first", value);
    setSelectedPos((prevSelectedPos) =>
      prevSelectedPos === value.job_id ? null : value.job_id
    );
    setSelectedPosId((prevSelectedPosId) =>
      prevSelectedPosId === value.pos_id ? null : value.pos_id
    );
  };


function formatAnyDate(date) {
  if (!date) return null;

  // This ensures you get the local date as yyyy-MM-dd
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}


  const handleOnDemandExtraction = () => {
    setLoading(true);
    if (selectedPos === null) {
      toast.error("Please select a data extraction platform");
      setLoading(false);
      return;
    }
    if (extractionType == "day" && dateForOnDemand === null) {
      toast.error("Please select a date");
      setLoading(false);
      return;
    }
    if (extractionType !== "day" && dateRange[0].startDate === null) {
      toast.error("Please select a date range");
      setLoading(false);
      return;
    }
    if (extractionType === "") {
      toast.error("Please select an extraction type");
      setLoading(false);
      return;
    }
    const body = {
      report_type: reportType,
      job_id: selectedPos,
      extraction_type: extractionType,
      start_date:
        extractionType !== "day"
          ? formatAnyDate(dateRange[0].startDate)
          : dateForOnDemand,
      end_date:
        extractionType !== "day"
          ? formatAnyDate(dateRange[0].endDate)
          : dateForOnDemand,
      debug: false,
      frequency: jobFrequency,
      job_execution_start_date: formatAnyDate(jobDateRange[0]?.startDate),
      job_execution_end_date: formatAnyDate(jobDateRange[0]?.endDate),
      job_execution_time: time,
    };
 
    onDemandExtraction(body)
      .then((data) => {
        toast.success("Job scheduled successfully");
        setSelectedPos(null);
        setDateForOnDemand(null);
        // navigate(`/restaurants/${selectedPos}/scrapper-processes/job-logs/`);
        setLoading(false);
      })
      .catch((error) => {
        toast.error("Something went wrong");
        setSelectedPos(null);
        setDateRange([
          {
            startDate: null,
            endDate: null,
            key: "selection",
          },
        ]);
        setLoading(false);
      });
  };

  useEffect(() => {
    const chicagoTime = toZonedTime(new Date(), "America/Chicago");
    const formattedToday = chicagoTime.toISOString().split("T")[0];
    setDateForOnDemand(formattedToday);
    setJobDateRange([
      {
        startDate: chicagoTime,
        endDate: chicagoTime,
        key: "selection",
      },
    ]);

    posForOnDemand.forEach((pos) => {
      if (pos.pos_name === "clover") {
        setSelectedPos(pos.job_id);
      }
    });
    handleTimeNow();
    // setDateForOnDemand/
  }, []);
  const handleTimeChange = (e) => {
    const localTime = e.target.value;
    const date = new Date();
    date.setHours(localTime.split(":")[0], localTime.split(":")[1]);
    const chicagoTime = toZonedTime(date, "America/Chicago");
    const formattedUTC = formatInTimeZone(
      chicagoTime,
      "UTC",
      "yyyy-MM-dd'T'HH:mm:ssXXX"
    );

    setTime(localTime);
  };
  const handleTimeNow = () => {
    const now = new Date();
    const chicagoTime = toZonedTime(now, "America/Chicago");

    // Format the time to HH:mm for the input
    const hours = String(chicagoTime.getHours()).padStart(2, "0");
    const minutes = String(chicagoTime.getMinutes()).padStart(2, "0");
    const formattedTime = `${hours}:${minutes}`;

    setTime(formattedTime);
  };
  return (
    <>
      <Modal
        show={show}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={onHide}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            On Demand Report Extraction
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            maxHeight: "450px",
            overflowY: "auto",
          }}
        >
          <Form.Group>
            <Form.Label>Restaurant ID:</Form.Label>
            <Form.Control type="text" value={id} readOnly />
          </Form.Group>
          <Form.Group>
            <Form.Label>Select Data Extraction Platform</Form.Label>
            {posForOnDemand.map((pos) => (
              <Form.Check
                key={pos.job_id}
                type="radio"
                label={pos.pos_name}
                value={JSON.stringify(pos)}
                checked={selectedPos === pos.job_id}
                onChange={handlePosChange}
              />
            ))}
          </Form.Group>
          <Form.Group>
            <Form.Label>Select Report Type</Form.Label>
            <Form.Control
              as="select"
              value={reportType}
              onChange={(e) => setReportType(e.target.value)}
            >
              <option value="all">All</option>
              {isLoading && <option value="loading">Loading...</option>}
              {isError && <option value="error">Error fetching data</option>}
              {data &&
                data?.report_names?.map((report) => (
                  <option
                    key={report}
                    value={report}
                    style={{ textTransform: "capitalize" }}
                  >
                    {report}
                  </option>
                ))}

              {/* <option value="product">Product</option>
              <option value="labor">Labor</option>
              <option value="discount">Discount</option> */}
            </Form.Control>
          </Form.Group>
          <Form.Group>
            <Form.Label>Select Extraction Type</Form.Label>
            <Form.Control
              as="select"
              value={extractionType}
              onChange={(e) => setExtractionType(e.target.value)}
            >
              <option value="" disabled>
                Select Extraction Type
              </option>
              <option value="day">Daily</option>
              <option value="range">Range</option>
              <option value="summary">Summary</option>
            </Form.Control>
          </Form.Group>
          <Form.Group>
            <Form.Label>Select Frequency</Form.Label>
            <Form.Control
              as="select"
              value={jobFrequency}
              onChange={(e) => setJobFrequency(e.target.value)}
            >
              <option value="" disabled>
                Select Frequency
              </option>
              <option value="one time">One Time</option>
            </Form.Control>
          </Form.Group>
          <div className="d-flex flex-column flex-md-row justify-content-between">
            {extractionType == "day" ? (
              <Form.Group className="my-3">
                <Form.Label>Select Extraction Date</Form.Label>
                <br />
                <input
                  type="date"
                  value={dateForOnDemand}
                  onChange={(e) => {
                    setDateForOnDemand((prevDate) => e.target.value);
                  }}
                  className="form-control"
                />
              </Form.Group>
            ) : (
              <Form.Group className="my-3">
                <Form.Label>Select Extraction Date</Form.Label>
                <br />
                <DateRange
                  id="dateRange"
                  editableDateInputs={true}
                  onChange={(item) => setDateRange([item.selection])}
                  moveRangeOnFirstSelection={false}
                  ranges={dateRange}
                  format="yyyy-MM-dd"
                />
              </Form.Group>
            )}
            <Form.Group className="my-3">
              <Form.Label>Select Job Execution Date Range:</Form.Label>
              <br />
              <DateRange
                id="executionDateRange"
                editableDateInputs={true}
                onChange={(item) => setJobDateRange([item?.selection])}
                moveRangeOnFirstSelection={false}
                ranges={jobDateRange}
                format="yyyy-MM-dd"
              />
            </Form.Group>
          </div>
          <Form.Group>
            <Form.Label>Job Execution Time </Form.Label>
            <div style={{ display: "flex", flexDirection: "row", gap: 4 }}>
              <Form.Control
                value={time}
                type="time"
                onChange={handleTimeChange}
              />
              <Button onClick={handleTimeNow}>Now</Button>
            </div>
            <p style={{ fontSize: 12, fontWeight: 400, paddingTop: 8 }}>
              Note :- Timezone America/Chicago
            </p>
          </Form.Group>
        </Modal.Body>
        <div className="d-flex my-3 mx-3 justify-content-end">
          <button
            className="btn btn-primary"
            disabled={loading}
            onClick={() => {
              handleOnDemandExtraction();
            }}
          >
            {loading ? "Extracting" : "Extract"}
          </button>
        </div>
        <Modal.Footer>
          <Button variant="danger" onClick={onHide}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <ToastContainer />
    </>
  );
}
